<template>
    <v-expansion-panels v-model="collapse">
        <v-expansion-panel>
            <v-expansion-panel-header>{{ $t('corporate.administration.history.title').replace('%title%', title) }}</v-expansion-panel-header>
            <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>
            <v-divider></v-divider>
            <v-expansion-panel-content>
                <template v-if="hasItems">
                    <v-pagination
                        v-if="pagination.show"
                        v-model="pagination.current"
                        :length="pagination.length"
                        circle
                        class="mt-4"
                    ></v-pagination>
                    <template v-for="(item, index) in items">
                        <v-card :key="index" class="mt-4" elevation="0" outlined>
                            <data-table-board-members-read :type="type" :item="item" :isHistory="true"></data-table-board-members-read>
                        </v-card>
                    </template>
                </template>
                <template v-else><div class="text-center mt-4"><span style="color: red">{{ $t('corporate.administration.history.empty') }}</span></div></template>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>
</template>

<script>
import API from '@/api'
import DataTableBoardMembersRead from '@/components/corporate/DataTableBoardMembersRead'

export default {
    name: 'history-captable',
    props: ['title', 'client', 'type', 'refreshHistoricMembers'],
    components: {
        DataTableBoardMembersRead
    },
    data: function () {
        return {
            loading: false,
            collapse: undefined,
            pagination: {
                show: false,
                current: 1,
                length: 0
            },
            items: [],
            hasItems: true,
            refreshHistoricMembersState: null
        }
    },
    watch: {
        collapse: {
            handler: function (val, oldVal) {
                if (oldVal !== val && val === 0) {
                    this.loadData()
                }
            },
            deep: true
        },
        'pagination.current': {
            handler: function (val, oldVal) {
                if (oldVal !== val) {
                    this.loadData()
                }
            },
            deep: true
        },
        refreshHistoricMembers: function (val, oldVal) {
            this.refreshHistoricMembersState = val
            if (oldVal !== val && val === true) {
                if (this.collapse === 0) {
                    this.loadData()
                }
            }
        }
    },
    methods: {
        loadData () {
            this.refreshHistoricMembersState = false
            this.$emit('update:refreshHistoricMembers', this.refreshHistoricMembersState)
            this.loading = true
            let endpoint = API.EndPoints.getCorporateBoardMembers
            let where = {
                client: { __type: 'Pointer', className: 'Client', objectId: this.$helpers.getCorporateClientId(this.$route.name, 'ClienteSocietarioAdministracao', this.$route.params.id) },
                isCurrent: false,
                type: this.type
            }
            const params = {
                limit: 5,
                skip: (this.pagination.current - 1) * 5,
                count: true,
                order: '-createdAt',
                where: JSON.stringify(where)
            }
            new API(endpoint, params).request().then(response => {
                this.items = Object.assign({}, response.data.results)
                this.pagination.length = Math.ceil(response.data.count / 5)
                this.hasItems = (response.data.count > 0)
                this.pagination.show = (response.data.count > 5)
                this.loading = false
            }, (e) => {
                this.$helpers.requestError(e)
            })
        }
    }
}
</script>
